
import React, { useEffect, useState } from 'react';
import { supabase } from '../integrations/supabase/client';
import PledgeAmount from './pledges/PledgeAmount';
import { formatCurrencyShort } from '../data/utils/money-utils';

interface PledgeCounterProps {
  totalPledges: number;
}

const PledgeCounter: React.FC<PledgeCounterProps> = ({ totalPledges: initialTotal }) => {
  const [totalPledges, setTotalPledges] = useState(initialTotal);
  
  useEffect(() => {
    const fetchPledges = async () => {
      try {
        const { data, error } = await supabase
          .from('region_pledges')
          .select('amount')
          .eq('payment_status', 'success');
          
        if (error) throw error;
        
        if (data && data.length > 0) {
          const dbTotal = data.reduce((sum, pledge) => sum + Number(pledge.amount), 0);
          console.log("PledgeCounter: Fetched pledge total:", dbTotal);
          setTotalPledges(initialTotal + dbTotal);
        }
      } catch (error) {
        console.error('Error fetching pledges:', error);
      }
    };
    
    fetchPledges();
    
    const channel = supabase
      .channel('public:region_pledges')
      .on('postgres_changes', 
        { 
          event: 'INSERT', 
          schema: 'public', 
          table: 'region_pledges',
          filter: 'payment_status=eq.success'
        },
        (payload) => {
          console.log("PledgeCounter: New pledge received:", payload.new.amount);
          setTotalPledges(current => current + Number(payload.new.amount));
        }
      )
      .subscribe();
      
    return () => {
      supabase.removeChannel(channel);
    };
  }, [initialTotal]);
  
  return <PledgeAmount amount={totalPledges} />;
};

export default PledgeCounter;
